/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var accordionExists = function (el) {
        if (!el.querySelector('.accordion')) {
            return;
        }
        MoyaLoader.js('/static/local/ext-accordion/js/accordion.min.js').then(function () {
            var accordion = MoyaContainer.get('ext.accordion');
            accordion.init();
        });
    };
    accordionExists(document);
    MoyaEventHandler.on('modal.opened', function (e) {
        accordionExists(e.modal.element);
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
